import { Caption } from '@cian/ui-kit';
import * as React from 'react';

import styles from './CardSubtitle.css';
import { ICardSubtitle, ISubtitleItem } from '../../../../../types/chatHeader';
import { CardSubtitleIcon } from '../CardSubtitleIcon';

export const CardSubtitle: React.FC<ICardSubtitle> = ({ primary, secondary }) => {
  const subtitleItems = React.useMemo(
    () => [primary, secondary].filter(Boolean) as ISubtitleItem[],
    [primary, secondary],
  );

  return (
    <div className={styles['subtitle']}>
      {subtitleItems.map(({ text, icon }, index) => (
        <div className={styles['subtitle__item']} key={index}>
          {icon && <CardSubtitleIcon {...icon} />}

          <Caption color="text-secondary-default">{text}</Caption>
        </div>
      ))}
    </div>
  );
};
